<script>
    export let wasm;
    export let config;

    import SegmentedButton, { Segment, Label as SegmentLabel } from "@smui/segmented-button";
    import Button, { Label as ButtonLabel } from "@smui/button";
    import Chip, { Set, Text } from "@smui/chips";
    import { getRandomItems, selectItemsWithChance } from "../utils/math"

    // grab options from rust
    let heritageOptions = wasm.v1_heritage_options();
    let genderOptions = wasm.v1_gender_options();
    let ageOptions = wasm.v1_age_options();
    let hairstyleOptions = wasm.v1_hairstyle_options();
    let haircolorOptions = wasm.v1_haircolor_options();
    let attireOptions = wasm.v1_attire_options();
    let sceneryOptions = wasm.v1_scenery_options();
    let expressionOptions = wasm.v1_expression_options();
    let miscellaneousOptions = wasm.v1_miscellaneous_options();

    // selection options
    let selectedHeritage = "";
    let selectedGender = ""; 
    let selectedAge = "";
    let selectedHairstyle = "";
    let selectedHaircolor = "";
    let selectedAttire = "";
    let selectedScenery = "";
    let selectedExpression = "";
    let selectedMisc = [];

    // hook updates to rust
    $: {
        try {
            // update selection options in rust (for structure look at builder.rs)
            let options = new wasm.SelectedOptionsV1(selectedHeritage, selectedGender, selectedAge, selectedHairstyle, selectedHaircolor, selectedAttire, selectedScenery, selectedExpression, selectedMisc);
            config.update_selected_options(options);
        } catch (e) {
            console.error("Error updating selected options. You likely added a new field and forgot to pass it in.", e);
        }
    }

    // methods

    // used to populate options from a saved config
    export const populateFromConfig = (selectedOptions) => {
        selectedHeritage = selectedOptions.selected_heritage;
        selectedGender = selectedOptions.selected_gender;
        selectedAge = selectedOptions.selected_age;
        selectedHairstyle = selectedOptions.selected_hairstyle;
        selectedHaircolor = selectedOptions.selected_haircolor;
        selectedAttire = selectedOptions.selected_attire;
        selectedScenery = selectedOptions.selected_scenery;
        selectedExpression = selectedOptions.selected_expression;
        selectedMisc = selectedOptions.selected_miscellaneous;
    };

    const randomizeSelections = () => {
        selectedHeritage = getRandomItems(heritageOptions, 1)[0];
        selectedGender = getRandomItems(genderOptions, 1)[0];
        selectedAge = getRandomItems(ageOptions, 1)[0];
        selectedHairstyle = getRandomItems(hairstyleOptions, 1)[0];
        selectedHaircolor = getRandomItems(haircolorOptions, 1)[0];
        selectedAttire = getRandomItems(attireOptions, 1)[0];
        selectedScenery = getRandomItems(sceneryOptions, 1)[0];
        selectedExpression = getRandomItems(expressionOptions, 1)[0];

        selectedMisc = selectItemsWithChance(miscellaneousOptions);
    }
</script>

<div>
    <div class="config-option">
        <h3 class="option-h3">Heritage</h3>
        <div style="display: flex; flex-direction: row; justify-content: space-between;">
            <SegmentedButton
                segments={heritageOptions}
                let:segment
                singleSelect
                bind:selected={selectedHeritage}
            >
                <Segment {segment}>
                    <SegmentLabel>{segment}</SegmentLabel>
                </Segment>
            </SegmentedButton>
            <Button on:click={randomizeSelections}><ButtonLabel>🎲 Randomize Options</ButtonLabel></Button>
        </div>

        <div class="config-option">
            <h3 class="option-h3">Presenting</h3>
            <SegmentedButton
                segments={genderOptions}
                let:segment
                singleSelect
                bind:selected={selectedGender}
            >
                <Segment {segment}>
                    <SegmentLabel>{segment}</SegmentLabel>
                </Segment>
            </SegmentedButton>
        </div>

        <div class="config-option">
            <h3 class="option-h3">Age</h3>
            <SegmentedButton
                segments={ageOptions}
                let:segment
                singleSelect
                bind:selected={selectedAge}
            >
                <Segment {segment}>
                    <SegmentLabel>{segment}</SegmentLabel>
                </Segment>
            </SegmentedButton>
        </div>

        <div class="config-option">
            <h3 class="option-h3">Hairstyle</h3>
            <SegmentedButton
                segments={hairstyleOptions}
                let:segment
                singleSelect
                bind:selected={selectedHairstyle}
            >
                <Segment {segment}>
                    <SegmentLabel>{segment}</SegmentLabel>
                </Segment>
            </SegmentedButton>
        </div>
    
        <div class="config-option">
            <h3 class="option-h3">Haircolor</h3>
            <SegmentedButton
                segments={haircolorOptions}
                let:segment
                singleSelect
                bind:selected={selectedHaircolor}
            >
                <Segment {segment}>
                    <SegmentLabel>{segment}</SegmentLabel>
                </Segment>
            </SegmentedButton>
        </div>

        <div class="config-option">
            <h3 class="option-h3">Attire</h3>
            <SegmentedButton
                segments={attireOptions}
                let:segment
                singleSelect
                bind:selected={selectedAttire}
            >
                <Segment {segment}>
                    <SegmentLabel>{segment}</SegmentLabel>
                </Segment>
            </SegmentedButton>
        </div>
    
        <div class="config-option">
            <h3 class="option-h3">Scenery</h3>
            <SegmentedButton
                segments={sceneryOptions}
                let:segment
                singleSelect
                bind:selected={selectedScenery}
            >
                <Segment {segment}>
                    <SegmentLabel>{segment}</SegmentLabel>
                </Segment>
            </SegmentedButton>
        </div>

        <div class="config-option">
            <h3 class="option-h3">Expression</h3>
            <SegmentedButton
                segments={expressionOptions}
                let:segment
                singleSelect
                bind:selected={selectedExpression}
            >
                <Segment {segment}>
                    <SegmentLabel>{segment}</SegmentLabel>
                </Segment>
            </SegmentedButton>
        </div>

        <div class="config-option">
            <h3 class="option-h3">Miscallaneous</h3>
            <Set
                chips={miscellaneousOptions}
                let:chip
                filter
                bind:selected={selectedMisc}
            >
                <Chip {chip} touch>
                    <Text>{chip}</Text>
                </Chip>
            </Set>
        </div>
    </div>
</div>

<style>
    .config-option {
        display: flex;
        flex-direction: column;
    }
    .option-h3 {
        margin-bottom: 6px;
    }
</style>